import {
  AreaList,
  Level,
} from "@/services/backend/qpm/buildings/types/building";
import { NewAreaPopOverButton } from "@/routes/processes/[processId]/qpm/manage-building/_components/new-area-popover-button";
import {
  AreaType,
  LevelType,
} from "@/services/backend/qpm/buildings/types/building-enum";
import t from "@/lang/lang";
import { AreaSegmentCollapsible } from "@/routes/processes/[processId]/qpm/manage-building/_components/area-segment-collapsible";
import { useEffect, useState } from "react";
import { LevelSelector } from "@/services/backend/qpm/buildings/components/level-selector";

export type BuildingScopedAreasComponentProps = {
  buildingId: string;
  areas: AreaList;
  areaType: AreaType;
  hint: string;
  createLabel: string;
  createDescription: string;
  emptyText: string;
  levels?: Level[];
  enableLevelSelection?: boolean;
};

export function BuildingScopedAreasComponent({
  buildingId,
  areas,
  areaType,
  hint,
  createLabel,
  createDescription,
  emptyText,
  levels = [],
  enableLevelSelection = false,
}: BuildingScopedAreasComponentProps) {
  const [selectedLevel, setSelectedLevel] = useState<Level | undefined>(
    undefined,
  );

  useEffect(() => {
    if (
      selectedLevel &&
      !levels.find((item) => item.base.id === selectedLevel.base.id)
    ) {
      setSelectedLevel(undefined);
    }
  }, [levels, selectedLevel]);

  return (
    <div className="space-y-3 p-4">
      <div className="flex items-end justify-between gap-2">
        <div className="text-muted-foreground text-sm">{hint}</div>
        <div className="flex items-end gap-2">
          {enableLevelSelection && (
            <LevelSelector
              levels={levels}
              selectedLevel={selectedLevel}
              handleLevelSelect={(value) => {
                const level = levels.find((item) => item.base.id === value);
                setSelectedLevel(level);
              }}
              buildingId={buildingId}
              allowNoLevel
              noLevelLabel={t("Ohne Ebene")}
              createLevelType={
                areaType === AreaType.AreaTypeOutside
                  ? LevelType.LevelTypeOutside
                  : LevelType.LevelTypeInside
              }
            />
          )}
          <NewAreaPopOverButton
            areaType={areaType}
            buildingId={buildingId}
            levelId={selectedLevel?.base.id}
            label={createLabel}
            description={createDescription}
          />
        </div>
      </div>
      {areas && areas.length > 0 ? (
        <div className="overflow-hidden rounded-md border">
          {areas.map((area) => (
            <AreaSegmentCollapsible
              key={area.base.id}
              id={area.base.id}
              buildingId={buildingId}
              area={area}
              isOpen={false}
            />
          ))}
        </div>
      ) : (
        <div className="text-muted-foreground rounded-md border p-4 text-sm">
          {t(emptyText)}
        </div>
      )}
    </div>
  );
}
